module.exports = __webpack_public_path__ + "img/case_4.89f533bc.png";